<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="30%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="120px" ref="model" :model="model" :rules="rules">
            <el-form-item label="项目名称" prop="Name">
                <el-input size="small" v-model="model.Name" auto-complete="off" placeholder="请输入项目名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="项目负责人" prop="Manager">
                <el-input size="small" v-model="model.Manager" auto-complete="off" placeholder="请输入项目负责人" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="授权方式" prop="AuthType" >
                <el-radio-group v-model="model.AuthType">
                    <el-radio label="限时授权"></el-radio>
                    <el-radio label="永久授权"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="授权到期时间" prop="DueTime" v-if="model.AuthType == '限时授权'">
                <el-date-picker
                    v-model="model.DueTime"
                    type="datetime"
                    placeholder="选择应用到期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="IP白名单" prop="IPList">
                <el-input size="small" v-model="model.IPList" auto-complete="off" placeholder="请输入IP白名单" maxlength="100"></el-input>
                <p style="color:red;line-height:1">tip：多个ip之间请用分号隔开</p>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {UpdateWorkSQ} from '../../api/authorize'
export default {
    data() {
        return {
            title: '编辑设备',
            name: 'add',
            model: {
                OID: null,    
                Manager: '', 
                Name: '',  
                AuthType: ''  
            },
            rules: {
                Manager: [{ required: true, message: '请输入项目负责人', trigger: 'blur' }],
                Name: [{ required: true,  trigger: 'blur',message: '请输入项目名称'}],
                AuthType: [{ required: true, message: '请输入授权方式', trigger: 'change' }],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        },
        data: {
            required: true,
            type: Object
        }
    },  
    mounted() {
        console.log(this.data)
        this.model = this.data;
        console.log(this.model)
    },
    methods: {
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                        this.UpdateWorkSQ()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'warning'
                    });
                }
            });
        },
        handleClose() {
            this.$emit('closeEditDialog')
        },
        UpdateWorkSQ() {
            if(this.model.AuthType == '限时授权') {
                this.model.AuthType = 2;
            }else if(this.model.AuthType == '永久授权') {
                this.model.AuthType = 1;
            }
            UpdateWorkSQ(this.model).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
                
            })
        },
    }
}
</script>

<style>

</style>